import React from 'react'
import './index.css'
import Swiperslider from '../Swiperslider/Index'
import ImageTag from '../ImageTag/Index';
import Container from '../Container/Index';
import Title from '../Title/Index'

const GallerySlider = ({ Data }) => {
  return (
   
           <Container _parentClass={'flex flex-wrap galleryImages p-100 pt-0 swiperbtn'}>
              <div className='col-12 w-full flex flex-wrap md:w-[80%] m-auto text-center'>
              <Title firstHeading={'Gallery'}/>
           <Swiperslider 
          spaceBetween={10} 
          slidesPerView={1}
          slidesPerGroup={1}
          mobslidesPerGroup={1}
          navigation={true} 
          timeDelay={8000}
        >
           {Data.map((logo, index) => (
            <div className='col-lg-11 col-12 m-auto text-center flex-center  position-relative' key={index}>
              <ImageTag ImagePath={logo.imagePath} ImageAlt={logo.imageAlt} ImageClass={'w-100'}/>
            </div>
          ))}
                </Swiperslider>
              </div>
           </Container>
   
  )
}

export default GallerySlider